// extracted by mini-css-extract-plugin
export default {"sectionApprovalButton":"SectionApprovalButton_sectionApprovalButton__EK3rW"};